import getSellingPriceForSellerQuery from './getSellingPriceForSellerQuery';
import getSparePartVATPrice from './getSparePartVATPrice';
import { searchSparePartsByNames } from './searchSparePartsByNames';

export const CommonSparePartsService = {
  searchSparePartsByNames,
  getSellingPriceForSellerQuery,
  getSparePartVATPrice,
};
